module.exports = __webpack_public_path__ + "img/typeAction.9c35cb4a.png";